import { MessageCircle, Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES, WHATSAPP_URL } from "@/lib/site";

const PRODUCTS = [
  {
    img: IMAGES.cards,
    alt: "Carta NFC Google Review fronte bianco e retro nero",
    name: "Carta NFC Classic",
    tag: "La best-seller",
    desc: "Elegante finitura bianca o nera, sta nel palmo di una mano. Perfetta da porgere al cliente al momento del conto o del saluto.",
    features: ["Chip NFC NTAG213", "QR di backup stampato", "PVC premium resistente", "Nessun abbonamento"],
  },
  {
    img: IMAGES.tapDemo,
    alt: "Carta blu TapGoogle.com con tap NFC e QR code",
    name: "Carta NFC Blu Google",
    tag: "Massima visibilità",
    desc: "Il blu iconico che i clienti riconoscono al volo: il messaggio 'review us on Google' è immediato e invita all'azione.",
    features: ["Design ad alto impatto", "Tap NFC istantaneo", "QR code ad alta definizione", "Personalizzabile col tuo link"],
  },
  {
    img: IMAGES.stand,
    alt: "Espositore da banco con QR code e chip NFC",
    name: "Espositore da Banco",
    tag: "Lavora da solo",
    desc: "Lo appoggi su cassa, bancone o tavolo e raccoglie recensioni in autonomia, anche mentre sei impegnato con altri clienti.",
    features: ["NFC + QR integrati", "Base stabile da banco", "Invito discreto ed elegante", "Ideale per attese e pagamenti"],
  },
];

export const Products = () => (
  <section id="prodotti" data-testid="products-section" className="mx-auto max-w-6xl px-5 py-24 sm:py-32">
    <Reveal className="max-w-2xl">
      <span className="rounded-full bg-blue-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-[#4285F4]">
        I prodotti
      </span>
      <h2 className="font-display mt-5 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
        Scegli il tuo alleato delle 5 stelle.
      </h2>
      <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
        Ogni prodotto arriva già configurato con il link recensioni della tua attività: lo scarti e funziona.
      </p>
    </Reveal>

    <div className="mt-14 grid gap-8 md:grid-cols-3">
      {PRODUCTS.map((p, i) => (
        <Reveal key={p.name} delay={0.12 * i} className="h-full">
          <article
            data-testid={`product-card-${i + 1}`}
            className="group flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:shadow-blue-500/10"
          >
            <div className="relative overflow-hidden bg-[#F8FAFC]">
              <span className="absolute left-4 top-4 z-10 rounded-full bg-white/90 px-3 py-1 text-xs font-bold uppercase tracking-wide text-[#4285F4] shadow-sm backdrop-blur">
                {p.tag}
              </span>
              <img
                src={p.img}
                alt={p.alt}
                className="aspect-square w-full object-cover transition-transform duration-700 group-hover:scale-108"
              />
            </div>
            <div className="flex flex-1 flex-col p-6">
              <h3 className="font-display text-xl font-bold text-slate-900">{p.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{p.desc}</p>
              <ul className="mt-4 flex flex-col gap-2">
                {p.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-sm text-slate-700">
                    <Check className="h-4 w-4 shrink-0 text-[#34A853]" /> {f}
                  </li>
                ))}
              </ul>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`product-whatsapp-cta-${i + 1}`}
                className="mt-6 flex items-center justify-center gap-2 rounded-full border border-[#25D366] px-5 py-2.5 text-sm font-semibold text-[#1EBE5D] transition-colors duration-300 hover:bg-[#25D366] hover:text-white"
              >
                <MessageCircle className="h-4 w-4" /> Richiedi preventivo
              </a>
            </div>
          </article>
        </Reveal>
      ))}
    </div>
  </section>
);
